import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Schedule from "./pages/Schedule";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Leaderboard from "./pages/Leaderboard";
import About from "./pages/About";
import Logout from "./pages/Logout";

const App = () => {
  return (
    // <>
    //     <Home />
    // </>
    <Router forceRefresh={true}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/standing" element={<Leaderboard />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/login" element={<Login/>} /> */}
      </Routes>
    </Router>
  );
};

export default App;
